import { z } from 'zod';
export const LayerSelectionSchema = z.object({
    part: z.string(),
    // For selectable parts (tintable: false in manifest): provide variant, omit tint.
    variant: z.string().optional(),
    // For tintable parts (tintable: true in manifest): provide tint (or omit for untinted Blank).
    // CSS hex color, e.g. "#a83200". variant and tint are mutually exclusive.
    tint: z.string().regex(/^#[0-9a-fA-F]{6}$/).optional(),
}).refine(data => !(data.variant !== undefined && data.tint !== undefined), { message: 'Provide variant (for selectable parts) or tint (for tintable parts), not both.' });
// Used by the equipment system to override sprite layers without touching stored appearance.
export const EquipmentSpriteOverridesSchema = z.object({
    layers: z.record(z.string(), LayerSelectionSchema.nullable()).optional(),
    // Maps output key → source animation folder name (e.g. { idle: 'IdleHoldingTool' }).
    animationOverrides: z.record(z.string(), z.string()).optional(),
});
export const CharacterDefinitionSchema = z.object({
    // Per-layer selections. Key is layer index as string (e.g. "0", "-1", "11").
    // null means skip this layer entirely.
    layers: z.record(z.string(), LayerSelectionSchema.nullable()),
    // Maps output key → source animation folder name. If absent, the manifest's defaultOutputKey mapping is used.
    animationOverrides: z.record(z.string(), z.string()).optional(),
});
export const CharacterDefinitionResponseSchema = z.object({
    definition: CharacterDefinitionSchema,
});
